import { render, staticRenderFns } from "./SamplesBoard.vue?vue&type=template&id=2a7d4177&scoped=true&"
import script from "./SamplesBoard.vue?vue&type=script&lang=ts&"
export * from "./SamplesBoard.vue?vue&type=script&lang=ts&"
import style0 from "./SamplesBoard.vue?vue&type=style&index=0&id=2a7d4177&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d4177",
  null
  
)

export default component.exports